<section class="instagram-feed-section" [@fadeInUp]="{ value: '', params: { delay: 100 } }">
  <div class="container">
    <div class="text-center mb-5">
      <h2 class="font-4xl font-bold">Seguici su Instagram</h2>
      <div class="divider-line mx-auto"></div>
      <p class="text-muted mt-3">Resta aggiornato con tutti i nostri contenuti pubblicati quotidianamente.</p>
    </div>

    @if (isLoading) {
      <div class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Caricamento...</span>
        </div>
      </div>
    } @else if (error) {
      <div class="alert alert-warning text-center" role="alert">
        <i class="fas fa-exclamation-triangle me-2"></i>
        {{ error }}
        <button class="btn btn-sm btn-outline-primary ms-3" (click)="loadPosts()">
          <i class="fas fa-redo me-1"></i>Riprova
        </button>
      </div>
    } @else if (instagramResponse$ | async; as instagramResponse) {
      @if (instagramResponse.posts.length === 0) {
        <div class="text-center py-5">
          <p class="text-muted">Nessun post disponibile al momento.</p>
        </div>
      } @else {
        <div class="row g-4">
          @for (post of instagramResponse.posts; track post.id) {
            <div class="col-lg-4 col-md-6">
              <div class="instagram-post-card" (click)="openInstagramPost(post)">
                <div class="post-image-wrapper">
                  @if (post.mediaType === 'VIDEO' && post.thumbnailUrl) {
                    <img 
                      [src]="post.thumbnailUrl" 
                      [alt]="post.caption || 'Post Instagram'"
                      class="post-image"
                      loading="lazy"
                    />
                  } @else {
                    <img 
                      [src]="post.mediaUrl" 
                      [alt]="post.caption || 'Post Instagram'"
                      class="post-image"
                      loading="lazy"
                    />
                  }
                </div>
                
                @if (post.caption) {
                  <div class="post-caption">
                    <p class="text-truncate mb-0">{{ post.caption }}</p>
                  </div>
                }
                
                <div class="post-footer">
                  <div class="post-footer-content">
                    <div class="post-stats">
                      @if (post.likeCount !== undefined) {
                        <span class="stat-item">
                          <i class="fas fa-heart me-1"></i>{{ post.likeCount }}
                        </span>
                      }
                      @if (post.commentsCount !== undefined) {
                        <span class="stat-item">
                          <i class="fas fa-comment me-1"></i>{{ post.commentsCount }}
                        </span>
                      }
                    </div>
                    <small class="post-date">
                      <i class="fab fa-instagram me-1"></i>
                      {{ getTimeAgo(post.timestamp) }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        
        <div class="text-center mt-5">
          <a 
            href="https://www.instagram.com/dopt_finanza" 
            target="_blank" 
            rel="noopener noreferrer"
            class="btn btn-primary btn-lg"
          >
            <i class="fab fa-instagram me-2"></i>
            Seguici su Instagram
          </a>
        </div>
      }
    }
  </div>
</section>

